import { Power2, TweenLite, TweenMax } from 'gsap';
import 'jquery';
import Swiper, { Autoplay, EffectFade, Pagination, Virtual } from "swiper";


const init = () => {
    Swiper.use([EffectFade, Pagination, Autoplay, Virtual])
    if ($('.swiper-hero-full-screen .swiper-slide').length > 0) {
        const swiper = new Swiper('.swiper-hero-full-screen', {
            loop: false,
            centeredSlides: true,
            speed: 2000,
            vertical: false,
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: { crossFade: false },
            virtualTranslate: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                bulletClass: 'swiper-pagination-bullet cursor-pointer hover:opacity-70 transition-opacity',
            },
            on: {
                progress: (swiper, progress) => {
                },
                init: (sw) => {
                    const currentIndex = $(sw.el).find('.swiper-pagination-count .current-index');
                    const totalCount = $(sw.el).find('.swiper-pagination-count .total-count');
                    const currentProgress = $(sw.el).find('.swiper-pagination-count .current-progress');
                    $(totalCount).html(`0${sw.slides.length}`)
                    $(currentIndex).html('01')
                    $(currentProgress).width(`${(sw.activeIndex + 1) * 100 / sw.slides.length}%`)
                    TweenMax.to($('.swiper-slide-active [data-animate-up]'), 0, { y: '100%' })
                    $('.swiper-pagination-count,.swiper-pagination,.social-links').css({ opacity: 0 })
                },
                slideChangeTransitionStart: (swiper) => {
                    const currentIndex = $(swiper.el).find('.swiper-pagination-count .current-index');
                    const currentProgress = $(swiper.el).find('.swiper-pagination-count .current-progress');
                    $(currentIndex).html(`0${swiper.activeIndex + 1}`)
                    $(currentProgress).width(`${(swiper.activeIndex + 1) * 100 / swiper.slides.length}%`)

                    const sliderActive = $(swiper.el).find('.swiper-slide-active')
                    const otherSlides = $(swiper.el).find('.swiper-slide:not(.swiper-slide-active)')
                    // if (window.innerWidth > parseInt(tailwindConfig.screens.lg.replace('px', ''))) {
                    //     const preTurbolence = TweenMax.fromTo($(otherSlides).find('feTurbulence'), 2.5, {
                    //         attr: {"baseFrequency": 0.01},
                    //     }, {
                    //         attr: {"baseFrequency": 0.02},
                    //     });
                    //     const activeTurbolence = TweenMax.fromTo($(sliderActive).find('feTurbulence'), 5, {
                    //         attr: {"baseFrequency": 0.01},
                    //     }, {
                    //         attr: {"baseFrequency": 0.02},
                    //     });
                    //     TweenLite.to($(otherSlides).find('feDisplacementMap'), 2, {attr: {scale: 30}})
                    //     TweenLite.fromTo($(sliderActive).find('feDisplacementMap'), 4, {attr: {scale: 50}}, {attr: {scale: 0}})
                    // }

                    TweenMax.fromTo($('.swiper-slide-active [data-swiper-animate-up]'), 2, {
                        y: '100%',
                        ease: Power2.easeOut,
                    }, {
                        y: '0',
                        ease: Power2.easeOut,
                    })
                    TweenMax.fromTo($('.swiper-slide:not(.swiper-slide-active) [data-swiper-animate-up]'), 1, {
                        y: '0',
                        ease: Power2.easeOut,
                    }, {
                        y: '-100%',
                        ease: Power2.easeOut,
                    })
                },
                slideChangeTransitionEnd: (sw) => {
                },
            },
        })
        swiper?.autoplay?.stop()
        $(document).on('loader-hide', () => {
            TweenLite.to($('.swiper-pagination-count,.swiper-pagination,.social-links'), 1, {
                opacity: '1',
                ease: Power2.easeOut,
            })
            TweenMax.to($('.swiper-slide-active [data-animate-up]'), 1, { y: '0', ease: Power2.easeOut })
                .then(() => {
                    TweenMax.set($('.swiper-slide-active [data-animate-up]'), { clearProps: "y" });
                })
            swiper?.autoplay?.start()
        })
    }
}
$(document).on('page-loaded', init);

